import { Routes } from '@angular/router';
import { CustomerGuard } from '@next/core-lib/relationships';

import { deviceRedirectGuard } from '../shared/guards/device-redirect.guard';
import { moduleActivationGuard } from '../shared/guards/module-activation.guard';
import { AdviceComponent } from './components/advice/advice.component';

export const downyMildewRoutes: Routes = [
  {
    path: 'downy-mildew',
    redirectTo: 'downyMildew',
  },
  {
    path: 'downyMildew',
    component: AdviceComponent,
    canActivate: [CustomerGuard, deviceRedirectGuard, moduleActivationGuard('downy-mildew')],
  },
];
